import React from 'react';
import { useIntl } from 'react-intl';
import { ProposalAIPrimaryButton } from './ProposalAIPrimaryButton';
import { TextSegmentAIPanel } from './TextSegmentAIPanel';
import { useTextSegmentAI } from '../hooks';

interface Props {
  index: number;
}

export const TextSegmentAI: React.FC<Props> = ({ index }) => {
  const { formatMessage } = useIntl();
  const textAI = useTextSegmentAI(index);

  if (!textAI.shouldRender) {
    return null;
  }

  return (
    <div className="proposal-text-ai">
      {!textAI.isOpen ? (
        <ProposalAIPrimaryButton
          label={formatMessage({ id: 'proposal-ai.text.open' })}
          onClick={textAI.handleOpen}
          btnSelector="proposal-ai-text-open"
          style="outline"
          size="med"
          className="proposal-text-ai__trigger"
        />
      ) : (
        <TextSegmentAIPanel
          index={index}
          prompt={textAI.prompt}
          generated={textAI.generated}
          isGenerating={textAI.isGenerating}
          isGeneratedStale={textAI.isGeneratedStale}
          onPromptChange={textAI.setPrompt}
          onGenerate={textAI.handleGenerate}
          onApply={textAI.handleApply}
          onCancel={textAI.resetState}
        />
      )}
    </div>
  );
};
